import { utils as appClientUtils } from '@edf-pkg/app-client';
import * as appMain from '@edf-pkg/app-main';

import { axios } from '$app-web/api/axios';
import { transformToSnakeCase } from '$app-web/utils';

import { Endpoints } from '../constant';

interface Session {
    sTimeMs: number;
    pTimeMs: number;
    tlTypeId: number;
    rTimeMs: number;
    statusId: number;
    uuid: string;
    activityId: number;
    studyId: number;
    tlId: number;
    version: number;
    responses: Array<unknown>;
}

export async function submitSurveySession(sessions: Array<Session>) {
    const deviceId = appMain.utils.user.getDeviceId();
    const data = {
        device_id: deviceId,
        payload: { sessions_responses: transformToSnakeCase(sessions) },
    };

    try {
        const { status } = await axios.post(Endpoints.Activity.SubmitSurvey, appClientUtils.object.toFormData(data));

        if (status === 200) {
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
}
